import { Tag, TagLabel, TagCloseButton, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag } from 'api-paths-cas';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { getTagWithDescriptionAttached } from '../../../../utilities/tags';

export const CustomeTag = ({
  tag,
  onClick,
  canDelete,
  tagProps,
}: {
  tag: ITag;
  onClick: any;
  canDelete?: boolean;
  tagProps?: TagProps;
}) => {
  const programmableTags = useSelector(
    ({ programmableTags }: ApplicationState) => programmableTags.programmableTags || [],
  );
  const customTags = useSelector(({ config }: ApplicationState) => config.tags || []);
  const allUniTags = [...programmableTags, ...customTags];
  const tagWithDescriptionAttached = getTagWithDescriptionAttached(tag, allUniTags);

  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={
        <>
          <b>{tagWithDescriptionAttached.label}</b>
          <div>{tagWithDescriptionAttached.description}</div>
        </>
      }
    >
      <Tag
        size="xs"
        variant="subtle"
        minWidth="0"
        maxWidth={'12rem'}
        bgColor="utility.100"
        _dark={{
          bgColor: 'whiteAlpha.200',
          color: 'whiteAlpha.800',
        }}
        data-selector={`tag-${tag.id}`}
        {...tagProps}
      >
        <TagLabel textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" noOfLines={null}>
          {tag.label}
        </TagLabel>

        {canDelete && (
          <TagCloseButton
            aria-label="Remove tag"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onClick();
            }}
          />
        )}
      </Tag>
    </Tooltip>
  );
};
